export default __webpack_public_path__ + "static/media/Gabby.204bccad.jpg";